import React, { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import { motion } from "framer-motion";

import Banner from '../Components/Banner';
import StatisticsSection from '../Components/Statistics';
import FreeCounsellingForm from '../Components/FreeCounsellingForm';
import ServicesSection from '../Components/ServicesSection';
import DestinationCarousel from '../Components/DestinationCarousel';
import PremiumCounselling from '../Components/PremiumCounselling';
import Programs from '../Components/Programs';
import FaqSection from '../Components/FaqSection';
import HomeAbout from '../Components/HomeAbout';
import SubServiceHero from '../Components/HomeTestPrep';
import AboutInnovation from '../Components/Homestep';
import InfoSection from '../Components/About/InfoSection';
import { Helmet } from "react-helmet-async";

import bgvideo from '../Assets/novavideobanner.mp4';
import aboutImage2 from '../Assets/homepageabout.jpg';

const Home = () => {
  const [isMobile, setIsMobile] = useState(window.innerWidth < 768);

  useEffect(() => {
    const handleResize = () => setIsMobile(window.innerWidth < 768);
    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  const fadeUp = {
    hidden: { opacity: 0, y: 30 },
    visible: {
      opacity: 1,
      y: 0,
      transition: { duration: 0.6, ease: "easeOut" }
    }
  };

  const Wrapper = ({ children }) => {
    if (isMobile) {
      return <div>{children}</div>;
    }
    return (
      <motion.div
        initial="hidden"
        whileInView="visible"
        viewport={{ once: true, amount: 0.3 }}
        variants={fadeUp}
      >
        {children}
      </motion.div>
    );
  };

  return (
    
    <div>
       <Helmet>
      <script type="application/ld+json">
        {JSON.stringify({
          "@context": "https://schema.org",
          "@type": "EducationalOrganization",
          "name": "Nova EduBridge",
          "url": "https://novaedubridge.com/",
          "telephone": "+91-9902043004",
          "email": "info@novaedubridge.com",
          "address": {
            "@type": "PostalAddress",
            "streetAddress": "No.121, 1st Floor, Eshwar Plaza, 4th Main Road, Manjunatha Nagar",
            "addressLocality": "Bangalore",
            "addressRegion": "Karnataka",
            "postalCode": "560010",
            "addressCountry": "IN"
          }
        })}
      </script>
    </Helmet>
      {/* Banner */}
      <Wrapper>
        <Banner
          subtitle="Start Your Journey with"
           title="Best Study Abroad Consultants in Bangalore"
          description={`Top study abroad consultancy in Bangalore offering expert guidance for admissions, visas, and scholarships across leading global universities.
Start your international education journey with personalized counseling and end-to-end support you can trust.`}
          buttonText="Book Free Consultation"
          buttonLink="/Contact"
          backgroundVideo={bgvideo}
          videoUrl="https://www.youtube.com/watch?v=dQw4w9WgXcQ"
        />
      </Wrapper>

      {/* Sections */}
      <Wrapper><StatisticsSection /></Wrapper>
      <Wrapper><HomeAbout /></Wrapper>

      {/* Info Section (Fixed) */}
      <Wrapper>
        <InfoSection
          title="About"
          subtitle="Nova Edubridge"
          description={
            <>
              At Nova EduBridge, we want to help students find the international education that is good for them. We do this by understanding what each student is good at in school, what they want to do for a job, and what they want to achieve in life. This way, we can give them the advice at every step.
              <br /><br />
              We have a team of people who have been doing this work for a time, and they know what they are doing. Our team will help students to pick the university, fill out applications, and get the right visa. Our goal is to make everything go smoothly and for students to know what is happening every step of the way.
              <br /><br />
              People know that Nova EduBridge is the{" "}
              <Link to="/Contact" className="keyword-text">
                <b>best study abroad consultant in Bangalore</b>
              </Link>.
              {" "}We know a lot about the industry. We always put the student first. We try to make the whole process easy and not too stressful. From the time we talk to a student to after they get into a university, we are here to help and make things simple. Our team wants students to be able to make choices that will help them in the future. At Nova EduBridge, we are always thinking about the students and what they need.
            </>
          }
          image={aboutImage2}
          videoLink="https://example.com/video"
          reverse={true}
        />
      </Wrapper>

      <Wrapper><FreeCounsellingForm /></Wrapper>
      <Wrapper><SubServiceHero /></Wrapper>
      <Wrapper><AboutInnovation /></Wrapper>
      <Wrapper><ServicesSection /></Wrapper>
      <Wrapper><DestinationCarousel /></Wrapper>
      <Wrapper><PremiumCounselling /></Wrapper>
      <Wrapper><Programs /></Wrapper>
      <Wrapper><FaqSection /></Wrapper>
    </div>
  );
};

export default Home;
